import {ProductVariant} from "@/models/ProductVariant";

export class FastProductVariant extends ProductVariant {
  protected $endpoint: string = '/fast-product-variants';

  public get autocompleteName(): string {
    return [
      this.product_name ? this.product_name : '',
      this.color && typeof this.color !== 'string' ? this.color.name : '',
      this.size && typeof this.size !== 'string' ? this.size.name : '',
      this.upc ? this.upc : '',
    ]
      .filter((item) => !!item)
      .join(' - ');
  }
}
